// @flow
import * as React from "react";

import { MoonOutlined, SunOutlined } from "@ant-design/icons";

import { useTheme } from "hooks/useTheme";

function ThemeToggle(): React.Node {
  const { theme, toggleTheme } = useTheme();

  return (
    <li className="nav-item ThemeToggle d-flex align-items-center">
      <button
        type="button"
        className="Header-control Header-control--icon"
        aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
        onClick={toggleTheme}>
        {theme === "dark" ? <SunOutlined /> : <MoonOutlined />}
      </button>
    </li>
  );
}

export default ThemeToggle;
